import { Autocomplete } from "@react-google-maps/api";
import { Form, Formik } from "formik";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { FaEyeSlash } from "react-icons/fa";
import { IoMdSearch } from "react-icons/io";
import { IoEyeSharp } from "react-icons/io5";
import { PiMapPinLineFill } from "react-icons/pi";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ModalAlt from "../../components/modal/ModalAlt";
import { ERROR_MSG } from "../../constants/common";
import {
    REMOVE_REDIRECT_PATH,
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../constants/contexConstant";
import {
    CONSUMER_OWNER_ONBOARDING_API_ENDPOINT,
    SIGNUP_CONSUMER_ENDPOINT,
    TIMELINE,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import {
    debouncedEmailValidation,
    debouncedPhoneValidation,
    getCleanedAddressFromAutoComplete,
    getURLQueryParams,
} from "../../helpers/helpers";
import useAuth from "../../hooks/useAuth";
import { check } from "../../resources/js/images";
import { handleResentOTP } from "../../services/apiRequest";
import auth from "../../services/auth";
import request from "../../services/request";
import Container from "../../shared/Container";
import H1 from "../../shared/typography/H1";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import BottomDrawer from "../../shared/ui/Drawer/BottomDrawer";
import DateTimePickerBlockFormik from "../../shared/ui/Form/DateTimePickerBlockFormik";
import FormikLabeledInput from "../../shared/ui/Form/FormikLabeledInput";
import FormikLabeledTextArea from "../../shared/ui/Form/FormikLabeledTextArea";
import { onboardingValidationSchema } from "../../shared/ui/Form/schema";
import ReusableMap from "../../shared/ui/Map";
import OTP from "../../shared/ui/OTP";
import Stepper from "../../shared/ui/Stepper";

const center = {
    lat: 18.5204303,
    lng: 73.8567437,
};

export const DatePickerWrapper = styled.div`
    .react-calendar {
        font-family: Urbanist, sans serif;
    }

    .react-date-picker__wrapper {
        border: none !important;
    }
    .react-date-picker {
        height: 40px;
    }
    @media (min-width: 1024px) {
        .react-date-picker {
            height: 47px;
        }
    }

    @media (min-width: 1536px) {
        .react-date-picker {
            height: 53px;
        }
    }
    .react-calendar__tile {
        color: #171d39;
        font-size: 1.5rem;
    }
    .react-calendar__tile:disabled {
        background-color: #dbdbdc !important;
    }
    .react-calendar__tile--now {
        background-color: white !important;
    }
    .react-calendar__tile--active {
        background-color: #171d39 !important;
        color: white;
        border-radius: 55%;
    }
    .react-calendar__navigation button:disabled {
        background-color: white !important;
    }
    .react-calendar__navigation__prev2-button {
        display: none;
    }
    .react-calendar__navigation__next2-button {
        display: none;
    }
    abbr[title] {
        text-decoration: none;
        color: #b5bec6;
        font-size: 1rem;
        font-weight: 500;
    }
`;
const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    electricalBill: "",
    date: new Date(),
    hour: 10,
    minutes: 0,
    billingName: "",
    address: "",
    customAddress: "",
    city: "",
    state: "",
    pincode: "",
    referralCode: "",
    useManualAddress: false,
    salesCode: "",
    lat: center.lat,
    lng: center.lng,
};
export const onboardingSteps = [
    "Profile information",
    "Site visit information",
    "Confirmation ",
];
/* @DESC:: Delete once Hero details verified @habib610 Fri October 18,2024 */
const HeroDetails = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const referralCode = getURLQueryParams(location, "code");
    const [externalErrors, setExternalErrors] = useState({});
    const { state, dispatch } = useContextState();
    const { isAuth } = useAuth(location?.pathname, dispatch);
    const autocompleteRef = useRef(null);

    const [markerPointA, setMarkerPointA] = useState(center);
    const siteRef = useRef(null);
    const [confirmAddress, setConfirmAddress] = useState(false);

    const [currentStep, setCurrentStep] = useState(
        state?.user?.plant?.status ? 4 : state.user ? 2 : 1
    );

    const [getOtp, setGetOtp] = useState(false);

    const [autoFillAddress, setAutoFillAddress] = useState(
        "Pune, Maharashtra, India"
    );

    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const getProfile = async () => {
            if (state.user && isAuth) {
                let status = state?.user?.plant?.status;
                if (status) {
                    setCurrentStep(3);
                } else {
                    setCurrentStep(2);
                }
            }
        };

        getProfile();
    }, []);

    const handleGetOTP = async (values) => {
        dispatch({ type: SET_LOADER });
        const reqData = {
            name: values.name,
            email: values.email,
            phone: `91${values.phoneNumber}`,
            password: values.password,
        };

        try {
            await request.post({
                endpoint: SIGNUP_CONSUMER_ENDPOINT,
                body: reqData,
            });

            toast.success("OTP has been sent!");

            setGetOtp(true);
        } catch (err) {
            toast.error(err || ERROR_MSG);
        } finally {
            dispatch({ type: RESET_LOADER });
        }
    };

    const handleSignup = async (values) => {
        dispatch({ type: SET_LOADER });

        try {
            const reqData = {
                name: values.name,
                email: values.email,
                phone: `91${values.phoneNumber}`,
                referralCode: values.referralCode || null,
                password: values.password,
                otp: values.otp,
                dateOfBirth: "18-10-1988",
            };

            await request.post({
                endpoint: SIGNUP_CONSUMER_ENDPOINT,
                body: reqData,
            });

            await auth.login({
                username: values.email,
                password: values.password,
                otpEnable: false,
            });

            setCurrentStep(2);
            dispatch({ type: REMOVE_REDIRECT_PATH });
        } catch (err) {
            toast.error(err || ERROR_MSG);
        } finally {
            dispatch({ type: RESET_LOADER });
        }
    };

    const handleSubmit = async (values, actions) => {
        if (currentStep === 1) {
            getOtp ? handleSignup(values) : handleGetOTP(values);
        } else if (currentStep === 2) {
            if (confirmAddress) {
                setCurrentStep(3);
            }
            setConfirmAddress((prev) => !prev);
        } else if (currentStep === 3) {
            handleCompleteOnboarding(values, actions);
        } else if (currentStep === 4) {
            try {
                dispatch({ type: SET_LOADER });
                await auth.getUserProfile(dispatch);
                dispatch({ type: RESET_LOADER });
                history.push(`${TIMELINE}/feasibility`);
            } catch (error) {
                toast.error(typeof error === "string" ? error : ERROR_MSG);
                dispatch({ type: RESET_LOADER });
            }
        }
    };

    const handleCompleteOnboarding = async (values, actions) => {
        try {
            const combinedMoment = moment(values.date)
                .hour(values.hour)
                .minute(values.minutes)
                .second(0)
                .millisecond(0);

            const unixTimestamp = combinedMoment.unix();
            const reqData = {
                date: `${unixTimestamp}`,
                bill: values.electricalBill,
            };

            if (values.referralCode) {
                reqData.referralCode = values.referralCode;
            }

            reqData.city = values.city;
            reqData.state = values.state;
            reqData.pinCode = values.pincode;
            reqData.address = values.address;
            reqData.latitude = values.lat;
            reqData.longitude = values.lng;
            reqData.propertyName = values.billingName;
            dispatch({ type: SET_LOADER });

            await request.authPost({
                endpoint: CONSUMER_OWNER_ONBOARDING_API_ENDPOINT,
                body: reqData,
            });
            dispatch({ type: RESET_LOADER });
            actions.resetForm();

            setCurrentStep(4);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };

    const handlePlaceChanged = async (setFieldValue) => {
        const place = autocompleteRef.current.getPlace();
        const suggestion = siteRef.current.value;

        if (!place || !place.geometry) {
            console.error("No details available for input: ");
            return;
        }

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const { city, state, cleanedAddress, pincode } =
            await getCleanedAddressFromAutoComplete(
                place,
                suggestion,
                lat,
                lng
            );

        const locationData = {
            lat,
            lng,
            address: cleanedAddress,
            city,
            state,
            pincode,
        };

        setAutoFillAddress(locationData);

        setFieldValue("address", cleanedAddress);
        setFieldValue("city", city);
        setFieldValue("state", state);
        setFieldValue("pincode", pincode);

        setMarkerPointA({ lat, lng });
        setFieldValue("lat", lat);
        setFieldValue("lng", lng);
    };

    const renderStepFields = ({
        values,
        errors,
        touched,
        showPassword,
        setFieldValue,
        currentStep,
        setErrors,
        isValid,
    }) => {
        switch (currentStep) {
            case 1:
                return (
                    <>
                        <div className="grid grid-cols-1 mt-2 lg:grid-cols-2  lg:gap-2">
                            <FormikLabeledInput
                                label="Full Name"
                                name="name"
                                type="text"
                                required
                            />
                            <div>
                                <FormikLabeledInput
                                    label="Email Id"
                                    name="email"
                                    type="text"
                                    required
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFieldValue("email", value);
                                        setExternalErrors((prev) => ({
                                            ...prev,
                                            email: "",
                                        }));
                                        debouncedEmailValidation({
                                            value,
                                            setExternalErrors,
                                        });
                                    }}
                                    errorMessage={
                                        externalErrors?.email ? (
                                            <div className="flex gap-0.5 flex-wrap justify-between w-full">
                                                Email number already in use
                                                <button
                                                    onClick={() =>
                                                        history.push("/login")
                                                    }
                                                    type="button"
                                                    className="text-blue text-xs md:text-sm underline inline-block"
                                                >
                                                    Login here
                                                </button>
                                            </div>
                                        ) : (
                                            externalErrors?.email
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2  lg:gap-2 lg:mt-2">
                            <div>
                                <FormikLabeledInput
                                    label="Phone Number"
                                    name="phoneNumber"
                                    type="text"
                                    required
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setFieldValue("phoneNumber", val);
                                        setExternalErrors((prev) => ({
                                            ...prev,
                                            phoneNumber: "",
                                        }));
                                        debouncedPhoneValidation({
                                            val,
                                            setExternalErrors,
                                        });
                                    }}
                                    helperMsg={
                                        !errors?.phoneNumber &&
                                        !externalErrors?.phoneNumber
                                            ? "An OTP will be sent to your phone number for verification"
                                            : ""
                                    }
                                    errorMessage={
                                        externalErrors?.phoneNumber ? (
                                            <div className="flex gap-0.5 flex-wrap justify-between w-full">
                                                Phone number already in use
                                                <button
                                                    onClick={() =>
                                                        history.push("/login")
                                                    }
                                                    type="button"
                                                    className="text-blue text-xs md:text-sm underline inline-block"
                                                >
                                                    Login here
                                                </button>
                                            </div>
                                        ) : (
                                            externalErrors?.phoneNumber
                                        )
                                    }
                                />
                            </div>
                            <FormikLabeledInput
                                label="Password"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                required
                                icon={
                                    showPassword ? (
                                        <FaEyeSlash />
                                    ) : (
                                        <IoEyeSharp />
                                    )
                                }
                                iconChange={() =>
                                    setShowPassword((pass) => !pass)
                                }
                                inputWrapper="rounded-l-md"
                            />
                        </div>
                        <DateTimePickerBlockFormik
                            label="Survey Date"
                            dateName="date"
                            hourName="hour"
                            minuteName="minutes"
                            minDate={new Date()}
                        />
                    </>
                );

            case 2:
                return (
                    <>
                        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-2 mt-2">
                            <FormikLabeledInput
                                label="Electrical Bill"
                                name="electricalBill"
                                type="text"
                                required
                            />
                            <FormikLabeledInput
                                label="Billing Name"
                                name="billingName"
                                required
                            />
                        </div>

                        <div className="grid grid-cols-1 ">
                            {isLoaded ? (
                                <div className="grid grid-cols-1  lg:gap-2">
                                    <Autocomplete
                                        onPlaceChanged={() =>
                                            handlePlaceChanged(setFieldValue)
                                        }
                                        onLoad={(autocomplete) => {
                                            autocompleteRef.current =
                                                autocomplete;
                                        }}
                                    >
                                        <FormikLabeledInput
                                            placeholder="Enter Your Location"
                                            label="Search Address"
                                            required
                                            ref={siteRef}
                                            name="address"
                                            id="siteLocationId"
                                            shadow={false}
                                            icon={<IoMdSearch />}
                                            iconWrapperClass="text-primary"
                                        />
                                    </Autocomplete>
                                </div>
                            ) : (
                                <p>Loading...</p>
                            )}
                        </div>

                        <div className="grid grid-cols-1 gap-1.6 mt-2">
                            <ReusableMap
                                center={markerPointA}
                                dimensions="w-[100%] h-[200px]"
                                address={autoFillAddress}
                                callback={() => setIsLoaded(true)}
                            />
                        </div>
                        {values.address && values.billingName && (
                            <div className="mt-2">
                                <div className="flex items-center gap-1">
                                    <PiMapPinLineFill
                                        size={26}
                                        className="text-orange"
                                    />
                                    <P className="text-sm text-orange font-vietnam">
                                        {values.billingName}
                                    </P>
                                </div>

                                <P className="text-xs font-vietnam">
                                    {values.address}
                                </P>
                            </div>
                        )}
                        <div className="mt-4">
                            <FormikLabeledInput
                                label="Referral Code"
                                name="referralCode"
                                value={referralCode}
                                errorMsg={errors.referralCode}
                            />
                        </div>
                    </>
                );
            case 3:
                return (
                    <>
                        <div className="mt-2">
                            <ReusableMap
                                center={markerPointA}
                                dimensions="w-[100%] h-[200px]"
                                address={autoFillAddress}
                                callback={() => setIsLoaded(true)}
                            />
                        </div>
                        <div className="my-2">
                            <FormikLabeledTextArea
                                label=" Site Address"
                                name="address"
                                rows="2"
                                required
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-1 md:gap-x-4 md:gap-y-1 ">
                            <FormikLabeledInput
                                label="City"
                                name="city"
                                required
                            />
                            <FormikLabeledInput
                                label="State"
                                name="state"
                                required
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-1 md:gap-x-4 md:gap-y-2 ">
                            <FormikLabeledInput
                                label="Pincode"
                                name="pincode"
                                required
                            />
                            <FormikLabeledInput
                                label="Sales Manager Code"
                                placeholder="Enter Code"
                                name="salesCode"
                            />
                        </div>
                    </>
                );

            case 4:
                return (
                    <div className="flex flex-col justify-center items-center mt-5">
                        <img
                            src={check}
                            className="w-44 h-44"
                            alt="check_icon"
                        />
                        <p className="text-center w-[70%] my-5">
                            An email will be sent to your registered email id
                            and we will contact you shortly to confirm your site
                            booking!
                        </p>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <>
            <Container className="px-0 mx-0 w-full max-w-7xl sm:container">
                <div className="flex justify-center xl:justify-between flex-wrap flex-col xl:flex-row items-center  xl:gap-9 sm:py-[10rem]  lg:py-[13rem] xl:py-[15rem] 2xl:py-[18rem]">
                    <div className="w-full hidden xl:w-[30%] xl:flex flex-col gap-4.8 xl:ml-4">
                        <H1 className={" text-white "}>Onboarding</H1>
                        <P className={"text-white"}>
                            Please share your details to get onboarded to our
                            platform
                        </P>
                    </div>
                    <div className="flex-1 w-full xl:w-1/5 2xl:w-1/2 xl:mr-4">
                        <div className="w-full mx-auto bg-white rounded-t-2.5 sm:rounded-1.5 sm:shadow-md p-2 md:py-4.6 md:px-3">
                            <div className="md:mx-4">
                                <Stepper
                                    steps={onboardingSteps}
                                    currentStep={currentStep}
                                />
                            </div>

                            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validationSchema={onboardingValidationSchema(
                                    currentStep
                                )}
                                validateOnBlur={true}
                                validateOnChange={true}
                                onSubmit={handleSubmit}
                            >
                                {({
                                    errors,
                                    touched,

                                    values,
                                    setErrors,
                                    setFieldValue,
                                    isValid,
                                }) => (
                                    <Form>
                                        {renderStepFields({
                                            values,
                                            errors,
                                            touched,
                                            showPassword,
                                            setFieldValue,
                                            currentStep,
                                            setErrors,
                                            isValid,
                                        })}

                                        {getOtp && currentStep === 1 && (
                                            <OTP
                                                otp={values.otp}
                                                onChange={(e) => {
                                                    setFieldValue(
                                                        "otp",
                                                        e.target.value
                                                    );
                                                }}
                                                error={errors.otp}
                                                errorMessage={errors.otp}
                                                handleResentOTP={async (
                                                    mode
                                                ) => {
                                                    await handleResentOTP(
                                                        mode,
                                                        values.phoneNumber,
                                                        () => null,
                                                        dispatch
                                                    );
                                                }}
                                            />
                                        )}

                                        <div className="mt-2">
                                            <Button
                                                type="submit"
                                                className="w-full flex justify-center px-1 sm:px-1.8 2xl:px-2 py-0.8 sm:py-1.2 xl:py-1.2"
                                                disabled={
                                                    Object.keys(errors).length >
                                                    0
                                                }
                                            >
                                                {currentStep === 1
                                                    ? getOtp
                                                        ? "Submit OTP"
                                                        : "Get OTP"
                                                    : currentStep === 2
                                                    ? "Confirm Address"
                                                    : currentStep === 3
                                                    ? "Submit Details"
                                                    : "Done"}
                                            </Button>
                                        </div>
                                        <div className="hidden lg:block">
                                            <ModalAlt
                                                isOpen={confirmAddress}
                                                contentClass={"bg-white"}
                                                onClose={() => {
                                                    setConfirmAddress(false);
                                                }}
                                                innerTimes={false}
                                                topPadding={"20px"}
                                            >
                                                {values.address &&
                                                    values.billingName && (
                                                        <div className="mt-2">
                                                            <div className="flex items-center gap-1">
                                                                <PiMapPinLineFill
                                                                    size={26}
                                                                    className="text-orange"
                                                                />
                                                                <P className="text-sm text-orange font-vietnam">
                                                                    {
                                                                        values.billingName
                                                                    }
                                                                </P>
                                                            </div>

                                                            <P className="text-xs font-vietnam">
                                                                {values.address}
                                                            </P>
                                                        </div>
                                                    )}

                                                <Button
                                                    type="submit"
                                                    className="w-full flex justify-center px-1 sm:px-1.8 2xl:px-2 py-0.8 sm:py-1.2 xl:py-1.2 mt-3"
                                                    disabled={
                                                        Object.keys(errors)
                                                            .length > 0
                                                    }
                                                >
                                                    Confirm Address
                                                </Button>
                                            </ModalAlt>
                                        </div>
                                        <div className="md:hidden">
                                            <BottomDrawer
                                                isOpen={confirmAddress}
                                                onClick={() =>
                                                    setConfirmAddress(
                                                        (prev) => !prev
                                                    )
                                                }
                                                contentClass="min-h-[35vh] p-2 rounded-t-4 bg-white"
                                                childrenClassName="bg-white"
                                                className="z-[102]"
                                            >
                                                {values.address &&
                                                    values.billingName && (
                                                        <div className="mt-2">
                                                            <div className="flex items-center gap-1">
                                                                <PiMapPinLineFill
                                                                    size={26}
                                                                    className="text-orange"
                                                                />
                                                                <P className="text-sm text-orange font-vietnam">
                                                                    {
                                                                        values.billingName
                                                                    }
                                                                </P>
                                                            </div>

                                                            <P className="text-xs font-vietnam">
                                                                {values.address}
                                                            </P>
                                                        </div>
                                                    )}

                                                <Button
                                                    type="submit"
                                                    className="w-full flex justify-center px-1 sm:px-1.8 2xl:px-2 py-0.8 sm:py-1.2 xl:py-1.2 mt-3"
                                                    disabled={
                                                        Object.keys(errors)
                                                            .length > 0
                                                    }
                                                >
                                                    Confirm Address
                                                </Button>
                                            </BottomDrawer>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default HeroDetails;
